import { render, staticRenderFns } from "./Project.old.vue?vue&type=template&id=27151d67"
import script from "./Project.old.vue?vue&type=script&lang=js"
export * from "./Project.old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports